// extracted by mini-css-extract-plugin
export default {"wrapper":"projectDirectorProfilePage_wrapper__WAxFm","gridWrapper":"projectDirectorProfilePage_gridWrapper__dqPpa","title":"projectDirectorProfilePage_title__0ViR9"};